import { render, staticRenderFns } from "./channellookup.vue?vue&type=template&id=250fbe3b&"
import script from "./channellookup.vue?vue&type=script&lang=js&"
export * from "./channellookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports